/* eslint-disable arrow-parens */
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import AccountSummary from './AccountSummary'
import cookies from '../../utils/cookies'
import getCurrentDomain from '../../utils/getCurrentDomain'

const AccountSummaryContainer = (props) => <AccountSummary {...props} />

AccountSummaryContainer.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
}

AccountSummaryContainer.getInitialProps = async ({ req, res }) => {
  const hostname = req?.headers.host.split(':')[0] || window.location.hostname
  const currentDomain = getCurrentDomain(hostname)

  if (res) {
    if (!cookies.get('STV_USERID', req)) {
      // 301 to homepage if not logged in
      res.redirect(301, `/`)
    }
  }

  return {
    title: `My Account | STV Player`,
    description: `Manage your account settings and subscriptions`,
    currentDomain,
  }
}
const mapStateToProps = (
  {
    user: {
      currentlySubscribed,
      firstName,
      lastName,
      vipOptIn,
      isLoggedIn,
      subscriptionMethod,
      subscriptionType,
    },
  },
  { currentDomain, loginService }
) => ({
  firstName,
  lastName,
  currentDomain,
  loginService,
  currentlySubscribed,
  vipOptIn,
  isLoggedIn,
  subscriptionMethod,
  subscriptionType,
})

export default connect(mapStateToProps)(AccountSummaryContainer)
